import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=5218f06b&scoped=true&"
import script from "./applicationList.vue?vue&type=script&lang=js&"
export * from "./applicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218f06b",
  null
  
)

export default component.exports